<template>
  <div id="createatask" class="createatask" >
    <b-modal id="modalCreateTask" title="Create Task" @ok="createActivity" size="sm">
      <form>
        <div class="form-group">
          <label class="control-label">Date</label>
          <input class="form-control input-lg" type="date" v-model="taskDate"/>
        </div>
        <div class="form-group">
          <label class="control-label">Title</label><br>
          <b-form-input v-model="headline"/>
        </div>
        <div class="form-group">
          <label class="control-label">Grade scale</label>
          <b-form-select v-model="taskGradingScales">
            <option v-for="gradingScale in gradingScales" v-bind:value="gradingScale.id">
              {{ gradingScale.title }}
            </option>
          </b-form-select>
        </div>
        <div class="form-group">
          <b-form-checkbox
            id="checkbox1"
            v-model="createAssignment"
            unchecked-value="not_accepted">Create assignment
          </b-form-checkbox>
        </div>
      </form>
    </b-modal>
  </div>
</template>
<script>
import api from '../api'
import moment from 'moment'

export default {
  name: 'CreateTask',
  props: ['groupId', 'gradingScales', 'syllabusIds'],
  data () {
    return {
      taskGradingScales: null,
      taskDate: new Date().toISOString().slice(0, 10),
      headline: null,
      createAssignment: false
    }
  },
  methods: {
    createActivity: function () {
      var formattedDate = moment(this.taskDate).format('YYYY-MM-DDTHH:mm:ss') + 'Z'

      api.createActivity(formattedDate, this.headline, this.taskGradingScales, 'task', this.groupId, this.syllabusIds).then(response => {
        if (response && this.createAssignment) {
          let groupIds = []
          groupIds.push(this.groupId)
          api.createAssignment(response.id, groupIds, this.headline, formattedDate)
        }
        this.$emit('getTaskPage', response)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CreateTask.vue